/* Impression SCDM — AMORCE DU CATALOGUE.  11 septembre 2026.

   A QUOI CA SERT. Le catalogue complet pese 1,2 Mo : 3 441 modeles repartis
   dans sept tables (scdm-modeles.js, scdm-simdut.js, scdm-tmd.js,
   scdm-mtq-v2.js, scdm-drapeaux-ca-us.js, scdm-pancartes.js et
   scdm-correctifs.js). Jusqu au 11 septembre 2026, ces sept fichiers etaient
   charges en balises BLOQUANTES sur la page d accueil : le client qui venait
   seulement televerser son fichier telechargeait quand meme les 3 441 modeles
   avant de voir quoi que ce soit.

   Ils sont maintenant charges A LA DEMANDE par sections/scdm-catalogue.liquid.
   Ce fichier-ci est le seul qui reste au chargement initial : il porte les
   DOUZE premiers modeles, juste assez pour que la galerie ne soit jamais vide
   pendant la seconde ou le vrai catalogue arrive.

   CE N EST PAS UNE SOURCE DE VERITE. Des que les vraies tables sont chargees,
   la grille est entierement repeinte a partir d elles et cette liste-ci n est
   plus jamais relue. Si un modele disparait ou change de nom, l ecart dure le
   temps d un battement de cil et se corrige tout seul.

   LES TUILES D AMORCE NE PORTENT PAS data-modele, mais data-amorce : les
   scripts qui ecoutent le clic sur [data-modele] (scdm-normes.js, entre
   autres) ne doivent pas se declencher sur un modele dont les tables ne sont
   pas encore la. Le clic sur une tuile d amorce declenche le chargement, puis
   rejoue le clic sur la VRAIE tuile.

   POUR REGENERER CETTE LISTE : ouvrir l accueil, laisser le catalogue se
   charger, puis lire window.SCDM_MODELES.BASE et
   window.SCDM_MODELES.LISTE.slice(0, 12). Rien d autre. */

window.SCDM_AMORCE = {
  BASE: 'https://cdn.shopify.com/s/files/1/1001/0184/9368/files/',
  LISTE: [
    { id: 'stationnement-interdit', nom: 'Stationnement interdit', f: '01-stationnement-interdit.png', taille: '6' },
    { id: 'payez-ici', nom: 'Payez ici', f: '02-payez-ici.png', taille: '6' },
    { id: 'pas-animaux', nom: "Pas d'animaux", f: '03-pas-animaux.png', taille: '6' },
    { id: 'surveillance-camera', nom: 'Surveillance par caméra', f: '04-surveillance-camera-2026.png', taille: '6' },
    { id: 'station-information', nom: "Station d'information", f: '08-station-information.png', taille: '6' },
    { id: 'toilettes', nom: 'Toilettes', f: '06-toilettes-2026.png', taille: '6' },
    { id: 'defense-de-passer', nom: 'Défense de passer', f: '10-defense-de-passer.png', taille: '6' },
    { id: 'attention-aux-animaux', nom: 'Attention aux animaux', f: '05-attention-aux-animaux.png', taille: '6' },
    { id: 'risques-et-perils', nom: 'À vos risques et périls', f: '09-a-vos-risques-et-perils.png', taille: '6' },
    { id: 'trousse-premiers-secours', nom: 'Trousse de premiers secours', f: 'Etiquette_verte_de_trousse_de_secours.png', larg: 10, haut: 4 },
    { id: 'attention', nom: 'Attention', f: 'Sticker_industriel_jaune_ATTENTION.png', larg: 10, haut: 4 },
    { id: 'brise', nom: 'Brisé', f: 'Autocollant_industriel_BRISE.png', larg: 10, haut: 4 }
  ]
};
